import { render, staticRenderFns } from "./ReviewListPaginated.vue?vue&type=template&id=df1ff408&scoped=true&lang=html&"
import script from "./ReviewListPaginated.vue?vue&type=script&lang=coffee&"
export * from "./ReviewListPaginated.vue?vue&type=script&lang=coffee&"
import style0 from "./ReviewListPaginated.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ReviewListPaginated.vue?vue&type=style&index=1&id=df1ff408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1ff408",
  null
  
)

component.options.__file = "ReviewListPaginated.vue"
export default component.exports